import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-timeline-action',
  imports: [SharedModule],
  templateUrl: './delete-timeline-action.component.html',
  styleUrl: './delete-timeline-action.component.scss'
})
export class DeleteTimelineActionComponent {

  @Input() title: string = 'Delete Timeline';
  @Input() description: string = 'Are you sure you want to delete this timeline?';
  @Input() timelineData: any[] = [];
  @Output() deleteTimeLine = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();
  @Input() deleteLoading: boolean = false;

  constructor() {
  }


  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete(){
    this.deleteTimeLine.emit();
  }



}
